export const setObjectProperty = (obj, path, value) => {
    path
        .split('.')
        .filter((k) => k.length > 0)
        .reduce((o, key, index, keys) => {
        if (index === keys.length - 1)
            o[key] = value;
        else
            o[key] = o[key] || {};
        return o[key];
    }, obj);
    return obj;
};
